/** EtherFi weETH — `getRate()` returns eETH-per-weETH at 1e18. */
export const EtherFiWeEthAbi = [
  {
    name: 'getRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const

/**
 * EtherFi LiquidityPool. `ethAmountLockedForWithdrawal` is the ETH reserved to
 * back already-requested withdrawals; the LP's free ETH balance minus this is
 * the genuine instant-exit buffer. (`getTotalPooledEther` is the protocol's
 * *total* pooled ETH ≈ TVL — NOT a buffer; intentionally unused for liquidity.)
 */
export const EtherFiLiquidityPoolAbi = [
  {
    name: 'getTotalPooledEther',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'ethAmountLockedForWithdrawal',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
